<div class="md-content rd-3" *ngIf="loading">
  <app-loader></app-loader>
</div>

<div class="md-content rd-3" *ngIf="!loading">
  <div class="md-header text-center">
    <h3>{{ 'SHARED.plansModal.title' | translate }}</h3>
    <p *ngIf="activePlan?.nickname">
      {{ 'SHARED.plansModal.planUsing' | translate }}
      <span>{{ 'SHARED.plansModal.planName' | translate : { nickname: activePlan?.nickname } }}</span>
      <span *ngIf="annualPlan"> ({{ 'SHARED.plansModal.annual-plan' | translate }})</span>
    </p>
    <i class="material-icons md-close" (click)="close()">close</i>
  </div>

  <div class="md-body pb-4">
    <div class="row">
      <div class="col-4 tab pr-0 text-center">
        <span class="tab-link" (click)="slideNum = 1" [ngClass]="{ active: slideNum === 1 }">{{
          'SHARED.plansModal.free' | translate
        }}</span>
      </div>
      <div class="col-4 tab pl-0 pr-0 text-center">
        <span class="tab-link" (click)="slideNum = 2" [ngClass]="{ active: slideNum === 2 }">{{
          'SHARED.plansModal.professional' | translate
        }}</span>
      </div>
      <div class="col-4 tab pl-0 text-center">
        <span class="tab-link" (click)="slideNum = 3" [ngClass]="{ active: slideNum === 3 }">{{
          'SHARED.plansModal.professionalPlus' | translate
        }}</span>
      </div>
    </div>

    <!-- FREE PLAN -->
    <div class="slide-content slide-1" *ngIf="slideNum === 1">
      <ul class="pricing">
        <li>
          {{ 'SHARED.plansModal.planBookingPage' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'SHARED.plansModal.planOnlineAgenda' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'SHARED.plansModal.planEmailReminders100' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'SHARED.plansModal.plan1Provider' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li class="cut">{{ 'SHARED.plansModal.planStats' | translate }}</li>
        <li class="cut">{{ 'SHARED.plansModal.syncGoogleCalendar' | translate }}</li>
        <li class="cut">{{ 'SHARED.plansModal.planSMSReminders' | translate }}</li>
      </ul>
      <p class="btn-rd" *ngIf="merchant?.plan === 'free'">{{ 'SHARED.plansModal.activePlan' | translate }}</p>
      <p class="sms" *ngIf="merchant?.numberOfProviders > 1">
        {{ 'SHARED.plansModal.haveMoreThanPossibleProviders' | translate : { numberOfProviders: merchant?.numberOfProviders } }}
      </p>
      <button
        [disabled]="merchant?.numberOfProviders > 1"
        class="btn btn-lg btn-success"
        *ngIf="merchant?.plan !== 'free'"
        (click)="activatePlan(freePlan?.id, freePlan?.bukId)"
      >
        {{ 'SHARED.plansModal.activatePlan' | translate }}
      </button>
      <p class="sms" *ngIf="merchant?.numberOfProviders <= 1" (click)="slideNum = 2">
        {{ 'SHARED.plansModal.useBukWithoutLimits' | translate }}
      </p>
    </div>

    <!-- PAYED PLANS -->
    <div class="slide-content slide-2" *ngIf="slideNum === 2 || slideNum === 3">
      <!-- PRO PLAN Features -->
      <ul class="pricing"  *ngIf="slideNum === 2">
        <li class="text-bold">
          {{ 'LANDING.pricing.everythingFromFree' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.advancedSettings' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <!-- <li>
          <i class="material-icons icon">check</i>
          {{ 'LANDING.pricing.features.advancedBookingPage' | translate }}
        </li> -->
        <li>
          {{ (withSMS ? 'LANDING.pricing.features.smsEmailUnlimited' : 'LANDING.pricing.features.email') | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.personalizedReminders' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li *ngIf="withSMS">
          <span> {{ 'LANDING.pricing.features.birthday' | translate }} </span>
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.googleCalendar' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.stats' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.marketingCredit' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.whatsapp' | translate }}
          <i class="material-icons icon">check</i>
        </li>
      </ul>


      <!-- PRO PLUS PLAN Features -->
      <ul class="pricing" *ngIf="slideNum === 3">
        <li class="text-bold">
          {{ 'LANDING.pricing.features.all_pro' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.googleReserve' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.googleReviews' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.marketingCredit2' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.websiteIntegration' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.personalizedEmails' | translate }}
          <i class="material-icons icon">check</i>
        </li>
        <li>
          {{ 'LANDING.pricing.features.apiAccess' | translate }}
          <i class="material-icons icon">check</i>
        </li>
      </ul>

      <!-- SMS -->
      <div class="pr-4 pl-4" >
        <div class="btn-group my-4 pricing-dropdown d-block ml-4 mr-4" dropdown>
          <button id="button-sms" dropdownToggle type="button" class="btn btn-primary dropdown-toggle w100">
            {{ withSMS ? withSMSlabel : withoutSMSlabel }}
            <span class="caret"></span>
          </button>
          <ul id="dropdown-sms" *dropdownMenu class="dropdown-menu" role="menu">
            <li role="menuitem" *ngFor="let option of [withSMSlabel, withoutSMSlabel]">
              <a class="dropdown-item" (click)="withSMS = option === withSMSlabel; refreshPrices()">{{ option }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Providers -->
      <div class="pr-4 pl-4">
        <div class="btn-group my-4 pricing-dropdown d-block ml-4 mr-4" dropdown>
          <button id="button-providers" dropdownToggle type="button" class="btn btn-primary dropdown-toggle w100">
            {{ providersAmount }}
            {{ providersAmount === 1 ? ('SHARED.plansModal.provider' | translate) : ('SHARED.plansModal.providers' | translate) }}
            <span class="caret"></span>
          </button>
          <ul id="dropdown-providers" *dropdownMenu class="dropdown-menu" role="menu">
            <li role="menuitem" *ngFor="let option of providersAmountOptions">
              <a class="dropdown-item" (click)="providersAmount = option; refreshPrices()"
                >{{ option }}
                {{ option === 1 ? ('SHARED.plansModal.provider' | translate) : ('SHARED.plansModal.providers' | translate) }}</a
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Period -->
      <div class="pr-4 pl-4">
        <div class="btn-group my-4 pricing-dropdown d-block ml-4 mr-4" dropdown>
          <button id="button-sms" dropdownToggle type="button" class="btn btn-primary dropdown-toggle w100">
            {{ annualPlan ? annualPlanLabel : monthlyPlanLabel }}
            <span class="caret"></span>
          </button>
          <ul id="dropdown-sms" *dropdownMenu class="dropdown-menu" role="menu">
            <li role="menuitem" *ngFor="let option of [annualPlanLabel, monthlyPlanLabel]">
              <a class="dropdown-item" (click)="annualPlan = option === annualPlanLabel; refreshPrices()">{{ option }}</a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Pricing -->
      <ng-container *ngIf="slideNum === 2">
        <h4 class="price" *ngIf="!annualPlan">
          {{
            plansService.getPlanPrice(selectedProPlanMonthly, showProPriceWithoutVat, providersAmount)
              | currency : selectedProPlanMonthly?.currency : 'symbol-narrow' : '1.0-2'
          }}
          <span>/{{ 'GENERAL.month' | translate }}</span>
        </h4>

        <h4 class="price d-flex justify-content-center" *ngIf="annualPlan">
          <span class="old-price mr-2">{{
            plansService.getPlanPrice(selectedProPlanMonthly, showProPriceWithoutVat, providersAmount)
              | currency : selectedProPlanMonthly?.currency : 'symbol-narrow' : '1.0-2'
          }}</span>
          <span>{{
            plansService.getPlanPrice(selectedProPlanAnnually, showProPriceWithoutVat, providersAmount) / 12
              | currency : selectedProPlanAnnually?.currency : 'symbol-narrow' : '1.0-2'
          }}</span>
          <span>/{{ 'GENERAL.month' | translate }}</span>
        </h4>
      </ng-container>

      <ng-container *ngIf="slideNum === 3">
        <h4 class="price" *ngIf="!annualPlan">
          {{
            plansService.getPlanPrice(selectedProPlusPlanMonthly, showProPlusPriceWithoutVat, providersAmount)
              | currency : selectedProPlusPlanMonthly?.currency : 'symbol-narrow' : '1.0-2'
          }}
          <span>/{{ 'GENERAL.month' | translate }}</span>
        </h4>

        <h4 class="price d-flex justify-content-center" *ngIf="annualPlan">
          <span class="old-price mr-2">{{
            plansService.getPlanPrice(selectedProPlusPlanMonthly, showProPlusPriceWithoutVat, providersAmount)
              | currency : selectedProPlusPlanMonthly?.currency : 'symbol-narrow' : '1.0-2'
          }}</span>
          <span>{{
            plansService.getPlanPrice(selectedProPlusPlanAnnually, showProPlusPriceWithoutVat, providersAmount) / 12
              | currency : selectedProPlusPlanAnnually?.currency : 'symbol-narrow' : '1.0-2'
          }}</span>
          <span>/{{ 'GENERAL.month' | translate }}</span>
        </h4>
      </ng-container>

      <p class="subtext2">
        <ng-container *ngIf="annualPlan && slideNum === 2">
          {{
            plansService.getPlanPrice(selectedProPlanAnnually, showProPriceWithoutVat, providersAmount)
              | currency : selectedProPlanAnnually?.currency : 'symbol-narrow' : '1.0-2'
          }}
          {{ 'SHARED.plansModal.annual-plan' | translate }}
          ({{ (showProPriceWithoutVat ? 'LANDING.pricing.vat_not_included' : 'LANDING.pricing.vat_included') | translate }})
        </ng-container>
        <ng-container *ngIf="!annualPlan && slideNum === 2">
          ({{ (showProPriceWithoutVat ? 'LANDING.pricing.vat_not_included' : 'LANDING.pricing.vat_included') | translate }})
        </ng-container>

        <ng-container *ngIf="annualPlan && slideNum === 3">
          {{
          plansService.getPlanPrice(selectedProPlusPlanAnnually, showProPlusPriceWithoutVat, providersAmount)
          | currency : selectedProPlusPlanAnnually?.currency : 'symbol-narrow' : '1.0-2'
          }}
          {{ 'SHARED.plansModal.annual-plan' | translate }}
          ({{ (showProPlusPriceWithoutVat ? 'LANDING.pricing.vat_not_included' : 'LANDING.pricing.vat_included') | translate }})
        </ng-container>
        <ng-container *ngIf="!annualPlan && slideNum === 3">
          ({{ (showProPlusPriceWithoutVat ? 'LANDING.pricing.vat_not_included' : 'LANDING.pricing.vat_included') | translate }})
        </ng-container>
      </p>

      <div class="d-flex flex-column" *ngIf="isActivePlan() && merchant?.planQuantity === providersAmount">
        <p class="btn-rd">
          {{ 'SHARED.plansModal.activePlan' | translate }}
        </p>

        <p class="btn-rd danger mt-2 clickable" (click)="cancelSubscription()" *ngIf="showCancelButton">
          {{ 'SHARED.plansModal.cancelSubscription' | translate }}
        </p>
      </div>

      <p class="sms" *ngIf="merchant?.numberOfProviders > providersAmount">
        {{
          'SHARED.plansModal.haveMoreThanNPossibleProviders'
            | translate : { numberOfProviders: merchant?.numberOfProviders, providersAmount: providersAmount }
        }}
      </p>

      <div class="pr-4 pl-4">
        <button
          [disabled]="merchant?.numberOfProviders > providersAmount"
          *ngIf="!isActivePlan() || merchant.planQuantity !== providersAmount"
          class="btn btn-lg btn-success w-100"
          (click)="activatePlan(getSelectedPlan()?.id, getSelectedPlan()?.bukId)"
        >
          {{ 'SHARED.plansModal.activatePlan' | translate }}
        </button>
      </div>

      <small
        *ngIf="isActivePlan() && merchant?.planQuantity === providersAmount"
        class="clickable mt-3 d-block underline"
        (click)="changePaymentMethod(getSelectedPlan()?.id)"
        >{{ 'SHARED.paymentModal.changePaymentMethod' | translate }}</small
      >

      <div class="big-plan rd-3" @flyInOut>
        <p>
          {{ 'SHARED.plansModal.forMoreThan' | translate }} <strong>{{maxSelfServiceNumberOfProviders}} {{ 'SHARED.plansModal.providers' | translate }}</strong>
          {{ 'SHARED.plansModal.contactUs' | translate }}
          <ng-container *ngIf="supportWhatsapp">
            Whatsapp <a href="{{supportWhatsapp.link}}">{{supportWhatsapp.text}}</a>
            {{ 'SHARED.plansModal.or' | translate }}
          </ng-container>
           <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
        </p>
      </div>
    </div>

    <app-alert type="danger" [msg]="errorMsg"></app-alert>
  </div>
</div>
